import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import {DataGrid, GridColDef, GridToolbar} from "@mui/x-data-grid";
import {Link} from "react-router-dom";
import axios from "axios";

interface EventOption {
    id: number
    name: string
    start: string | null
    end: string | null
    locked: boolean
    _count?: {registrations: number}
}

function formatDate(d: string | null): string {
    if (!d) return '—'
    return new Date(d).toLocaleDateString()
}

const columns: GridColDef[] = [
    {
        field: 'name', headerName: 'Event', flex: 1,
        renderCell: (params) => <Link to={String(params.row.id)}>{params.value}</Link>
    },
    {
        field: 'start', headerName: 'Start', width: 130,
        valueFormatter: (params: any) => formatDate(params.value)
    },
    {
        field: 'end', headerName: 'End', width: 130,
        valueFormatter: (params: any) => formatDate(params.value)
    },
    {
        field: 'registrations', headerName: 'Registrations', width: 130, align: 'right', headerAlign: 'right',
        valueGetter: (params: any) => params.row?._count?.registrations ?? 0
    },
]

export default function LogisticsEventLanding() {
    const [events, setEvents] = useState<EventOption[]>([])

    useEffect(() => {
        axios.get('/api/events').then(({data}) => setEvents(data)).catch(() => {})
    }, [])

    return (
        <React.Fragment>
            <Typography variant="h5" sx={{p: 2}}>Select an Event</Typography>
            <DataGrid
                slots={{toolbar: GridToolbar}}
                rows={events}
                columns={columns}
                autoHeight
                disableRowSelectionOnClick
                initialState={{pagination: {paginationModel: {pageSize: 20}}}}
            />
        </React.Fragment>
    )
}
